/** localStorage guards для Subscribe modal: frequency_cap, cooldown, stop_after_submit */

const PREFIX = 'sw_subscribe_';

function key(siteKey: string, suffix: string): string {
  return `${PREFIX}${siteKey}_${suffix}`;
}

function parseShows(raw: string | null): number[] {
  if (!raw) return [];
  try {
    const arr = JSON.parse(raw);
    return Array.isArray(arr) ? arr.filter((x) => typeof x === 'number') : [];
  } catch {
    return [];
  }
}

export function canShow(
  siteKey: string,
  opts: {
    frequency_cap?: { max_shows: number; window_days: number };
    cooldown_after_close_hours?: number;
    stop_after_submit?: boolean;
  }
): boolean {
  if (typeof localStorage === 'undefined') return true;
  try {
    if (opts.stop_after_submit) {
      const submitted = localStorage.getItem(key(siteKey, 'submitted'));
      if (submitted === '1') return false;
    }
    if (opts.cooldown_after_close_hours && opts.cooldown_after_close_hours > 0) {
      const closedRaw = localStorage.getItem(key(siteKey, 'closed'));
      if (closedRaw) {
        const closedTs = parseInt(closedRaw, 10);
        if (!isNaN(closedTs)) {
          const cooldownMs = opts.cooldown_after_close_hours * 60 * 60 * 1000;
          if (Date.now() - closedTs < cooldownMs) return false;
        }
      }
    }
    const cap = opts.frequency_cap;
    if (cap && cap.max_shows > 0 && cap.window_days > 0) {
      const windowMs = cap.window_days * 24 * 60 * 60 * 1000;
      const cutoff = Date.now() - windowMs;
      const shows = parseShows(localStorage.getItem(key(siteKey, 'shows'))).filter((t) => t >= cutoff);
      if (shows.length >= cap.max_shows) return false;
    }
    return true;
  } catch {
    return true;
  }
}

export function recordShow(siteKey: string): void {
  if (typeof localStorage === 'undefined') return;
  try {
    const shows = parseShows(localStorage.getItem(key(siteKey, 'shows')));
    shows.push(Date.now());
    localStorage.setItem(key(siteKey, 'shows'), JSON.stringify(shows));
  } catch {}
}

export function recordClose(siteKey: string): void {
  if (typeof localStorage === 'undefined') return;
  try {
    localStorage.setItem(key(siteKey, 'closed'), String(Date.now()));
  } catch {}
}

export function recordSubmit(siteKey: string): void {
  if (typeof localStorage === 'undefined') return;
  try {
    localStorage.setItem(key(siteKey, 'submitted'), '1');
  } catch {}
}
